// Generated file : do not modify
import Owner from '@/extend/classes/Owner';
import { ListFilter } from '@/extend/classes/ListData';
import ListData from '@/extend/classes/ListData';
import { NotifDefTypes } from '@/generated/classes/NotifDef';
import { storeSession } from '@/generated/stores';
import { type AxiosResponse } from 'axios';
import {getRequestConfig} from "@/framework/base/helpers/HttpHelper.ts";

// Contacts
export default class Contact  {
  // Identifiant unique
  public id: number;
  // Civilité
  public civiliteId: number;
  // Prénom
  public prenom: string;
  // Nom
  public nom: string;
  // Qualité
  public qualiteId: number;
  // Adresse mail
  public mailId: number;
  // Adresse mail
  public mail: string;
  // Numéro de téléphone
  public numeroId: number;
  // Téléphone
  public numero: string;
  // Adresse postale
  public adresseId: number;
  // Vérification demandée au serveur
  public verify: boolean;
  // Validation effectué par le serveur
  public valid: boolean;
  // Contact associé à un utilisateur
  public isUser: boolean;
  // Recipient id edusign
  public eduSignRecipientId: string;
  // GUID de création du store
  public createId: string;
  // Commande non exécutée
  public failed: boolean;
  // Donnée pouvant être  modifiée
  public canUpdate: boolean;
  // Donnée pouvant être supprimée
  public canDelete: boolean;
  // Display des objets
  public display: string;
  // Client
  public clientId: number;
  // Type de notification
  public notifDefType: NotifDefTypes;
  // Objet à l'origine de la requête
  public owner: Owner;

  constructor() {
    this.id = 0;
    this.civiliteId = 0;
    this.prenom = '';
    this.nom = '';
    this.qualiteId = 0;
    this.mailId = 0;
    this.mail = '';
    this.numeroId = 0;
    this.numero = '';
    this.adresseId = 0;
    this.verify = false;
    this.valid = false;
    this.isUser = false;
    this.eduSignRecipientId = '';
    this.createId = '';
    this.failed = false;
    this.canUpdate = true;
    this.canDelete = true;
    this.display = '';
    this.clientId = 0;
    this.notifDefType = NotifDefTypes.NONE;
    this.owner = new Owner();
  }

  public static fromJson (obj: Contact): Contact {
    const newContact: Contact = new Contact();
    newContact.id = obj.id;
    newContact.civiliteId = obj.civiliteId;
    newContact.prenom = obj.prenom;
    newContact.nom = obj.nom;
    newContact.qualiteId = obj.qualiteId;
    newContact.mailId = obj.mailId;
    newContact.mail = obj.mail;
    newContact.numeroId = obj.numeroId;
    newContact.numero = obj.numero;
    newContact.adresseId = obj.adresseId;
    newContact.verify = obj.verify;
    newContact.valid = obj.valid;
    newContact.isUser = obj.isUser;
    newContact.eduSignRecipientId = obj.eduSignRecipientId;
    newContact.createId = obj.createId;
    newContact.failed = obj.failed;
    newContact.canUpdate = obj.canUpdate;
    newContact.canDelete = obj.canDelete;
    newContact.display = obj.display;
    newContact.clientId = obj.clientId;
    newContact.notifDefType = obj.notifDefType;
    newContact.owner = JSON.parse(JSON.stringify(obj.owner));
    return newContact;
  }

  public toJsonContact (): string {
    const json = {
      civiliteId: this.civiliteId,
      prenom: this.prenom,
      nom: this.nom,
      qualiteId: this.qualiteId,
      mailId: this.mailId,
      mail: this.mail,
      numeroId: this.numeroId,
      numero: this.numero,
      adresseId: this.adresseId,
      verify: this.verify,
      valid: this.valid,
      isUser: this.isUser,
      eduSignRecipientId: this.eduSignRecipientId,
      canUpdate: this.canUpdate,
      canDelete: this.canDelete,
      notifDefType: this.notifDefType,
    }
    return JSON.stringify(json);
  }

  public fromContact (obj: Contact): void {
    this.id = obj.id;
    this.civiliteId = obj.civiliteId;
    this.prenom = obj.prenom;
    this.nom = obj.nom;
    this.qualiteId = obj.qualiteId;
    this.mailId = obj.mailId;
    this.mail = obj.mail;
    this.numeroId = obj.numeroId;
    this.numero = obj.numero;
    this.adresseId = obj.adresseId;
    this.verify = obj.verify;
    this.valid = obj.valid;
    this.isUser = obj.isUser;
    this.eduSignRecipientId = obj.eduSignRecipientId;
    this.createId = obj.createId;
    this.failed = obj.failed;
    this.canUpdate = obj.canUpdate;
    this.canDelete = obj.canDelete;
    this.display = obj.display;
    this.clientId = obj.clientId;
    this.notifDefType = obj.notifDefType;
    this.owner = obj.owner;
  }

  public compareContact (value: Contact): boolean {
    return (this.toJsonContact() == value.toJsonContact());
  }

  public cloneContact (): Contact {
    return Contact.fromJson(this);
  }

  public createForStoreContact (): Promise<Contact> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/contacts/', this, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              this.fromContact(res.data);
              resolve(this);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public updateForStoreContact (): Promise<Contact> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.put('api/contacts/', this, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              this.fromContact(res.data);
              resolve(this);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public deleteForStoreContact (): Promise<void> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.delete('api/contacts/' + this.id, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve();
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static list (filter: ListFilter): Promise<ListData> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/contacts/list', filter, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(res.data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static save (contact: Contact): Promise<Contact> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/contacts/save', contact, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(Contact.fromJson(res.data));
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static getForStore (id: number): Promise<ListData> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.get('api/Contacts/' + id.toString(), getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              const listData = res.data as ListData;
              listData.reccords[0] = Contact.fromJson(listData.reccords[0] as Contact);
              resolve(listData);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static get (id: number): Promise<Contact> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.get('api/Contacts/' + id.toString(), getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              const listData = res.data as ListData;
              const data = Contact.fromJson(listData.reccords[0] as Contact);
              resolve(data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  // eslint-disable-next-line
  public static getDate(contacts: Contact[]) {
  }
}
